import store from '@/store'

const items = [
  {
    header: 'menu.account-management',
  },
  {
    title: 'menu.cloud',
    icon: 'FileIcon',
    route: 'owner:cloud',
  },
  {
    title: 'menu.help',
    route: 'owner:help',
    icon: 'HelpCircleIcon',
  },
  {
    title: 'invoice.invoices',
    icon: 'DollarSignIcon',
    route: 'owner:invoices',
  },
  {
    title: 'notifications.title',
    icon: 'BellIcon',
    route: 'owner:notifications',
  },
  {
    title: 'menu.telegram-bot',
    icon: 'SendIcon',
    route: 'owner:telegram',
  },
  {
    title: 'menu.download_android_app',
    icon: 'DownloadIcon',
    href: () => store.getters['auth/androidAppUrl'] || '#',
    target: '_blank',
    rel: 'noopener noreferrer',
    hide: () => !store.getters['auth/androidAppUrl'],
    shared: true,
  },
]
export default items.map(item => ({ ...item, shared: item.shared !== false }))
